import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/components/Index';
import Policy from '@/components/Policy';
import Terms from '@/components/Terms';

Vue.use(Router);

export const routes= [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
	{
	  path: '/banking',
	  name: 'Banking',
	  component: Index
	},
	{
	  path: '/exchange',
	  name: 'Exchange',
	  component: Index
	},
	{
	  path: '/issuing',
	  name: 'Issuing',
	  component: Index
	},
	{
	  path: '/acquiring',
	  name: 'Acquiring',
	  component: Index
	},
	{
	  path: '/company',
	  name: 'Company',
	  component: Index
	},
    {
      path: '/policy',
      name: 'Policy',
      component: Policy
    },
	{
	  path: '/terms',
	  name: 'Terms',
	  component: Terms
	}
  ]
  
  const router =new Router({
	  mode: 'history',
	  routes,
	    scrollBehavior(to, from, savedPosition) {
	      // 1. 基础版：所有跳转都回到顶部
		  if('Banking'==to.name){
			   return { x: 0, y: 776 }
		  }else if('Exchange'==to.name){
			    return { x: 0, y: 2278 }
		  }else if('Issuing'==to.name){
			    return { x: 0, y: 1570 }
		  }else if('Company'==to.name){
			    return { x: 0, y: 2795 }
		  }else if('Acquiring'==to.name){
			    return { x: 0, y: 3253 }
		  }else{
	            return { x: 0, y: 0 }
		  }
	      // 2. 进阶版：返回时恢复位置，新跳转回到顶部（更友好）
	      // if (savedPosition) {
	      //   // 点击浏览器返回/前进时，恢复之前的滚动位置
	      //   return savedPosition
	      // } else {
	      //   // 正常跳转时，回到顶部
	      //   return { x: 0, y: 0 }
	      // }
	    }
  })
  
  export default router;



